import type { FaireProductEntity } from "../../entity_types/product";

export const p_6dnqzhx3bh: FaireProductEntity = {
  token: "p_6dnqzhx3bh",
  type: "product",
  name: "Energy Cleanse Aromatherapy Body & Room Myst",
  brandToken: "b_we9tdmh5ka",
  brandName: "The Sacred Wild Candle Co",
  imageUrl:
    "https://cdn.faire.com/fastly/423d9477b8355765101cb627d220924eb1bc83f009035622287e1402ec62025a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/bd4a510d9563fc45a46b2c6d5a8aab3441979ad70fe8bdbab827a019f0e24e7c.jpeg",
    "https://cdn.faire.com/fastly/6961e7c2189ff1fa1012b74bb7df16e4e74414a30c89ab0736a07bb31706a37a.jpeg",
    "https://cdn.faire.com/fastly/4162ad44d27c73ed7664fd8f862e74c1ead907cf1a0d7a129bb1aac43e3251f0.jpeg",
    "https://cdn.faire.com/fastly/62293f79840c3677b745d7432873caf2591332a6c385425f046c11d0dc87b625.jpeg",
    "https://cdn.faire.com/fastly/6c017799ced4af2b77582d592033ef145d910d986c2e4af38cac4b2ba3895fa0.jpeg",
    "https://cdn.faire.com/fastly/5d09fc810eeaddd9824b7a5161cee43ec169a784b044cfbe6346b4faf5fc4ffc.jpeg",
  ],
  priceDollars: 16.28,
  description:
    "Spray it out!  Release what's heavy with a heavenly blend of Lavender, Mint, and Sage. \nWe’ve taken our signature plant-based and non-toxic essential oil fragrances and formulated them into an indulgent room and body myst for an instant aromatherapeutic effect. \n\nBecause of our Natural Skin Safe Formulas (NO parabens, phthalates, aerosols, alcohol, or formaldehydes) - the oils can separate on the shelf...please shake occasionally! \n\nSpray this fragrant mist around your personal space and repeat this mantra: I release all energies that do not serve me. I release any worry from my body and my home. I release my attachments and trust the universe to guide me.\n\nHow to use : Shake well before use. Mist fresh sheets, towels, or sofa to refresh your space. Spray overhead, then take a walk on through. \n++++Please see our separate product listing to order testers++\n",
  tags: [],
  msrpDollars: 30.49,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:01:22.520Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
